const config = {
  env: 'dev',
  region: 'emea',
  page: '/ocp-dashboard',
  path: 'api/v2/appliances',
  get baseUrl() {
    return `${this.page}/${this.env}-${this.region}/${this.path}`;
  },
};

export const AZURE_AD_GROUP_IOT_DEV = 'group:default/dpo-plugin-iot-dev';
export const AZURE_AD_GROUP_IOT_STAGING =
  'group:default/dpo-plugin-iot-staging';
export const AZURE_AD_GROUP_IOT_PRODUCTION =
  'group:default/dpo-plugin-iot-production';
export const AZURE_AD_GROUP_IOT_PRODUCTION_EU =
  'group:default/dpo-plugin-iot-production-eu';
export const AZURE_AD_GROUP_IOT_PRODUCTION_APMEA =
  'group:default/dpo-plugin-iot-production-apmea';
export const AZURE_AD_GROUP_IOT_PRODUCTION_AMER =
  'group:default/dpo-plugin-iot-production-amer';

export const modifyRegionAndEnv = (env: string, region: string) => {
  config.env = env;
  config.region = region;
};

export const CONFIG = config;

export type UserToSubmit = {
  username: string;
  id: string;
  region: string;
  environment: string;
};
